import { KYMW9000Model } from '../kymw9000.model';
import { Injectable } from "@angular/core";
import { PlessHttp } from '../../../../shared/http/pless-http.service';
import { PlessDialogServiceSub } from '../../../../commons/kymw00/pless-dialog-service-sub';
import { PlessJsonResponderSub } from 'src/app/commons/kymw00/pless-json-responder-sub.service';
import { PlessRequest } from 'src/app/shared/vo/pless-request.model';
import { PlessViewUtilsSub } from 'src/app/commons/kymw00/pless-view-utils-sub.service';

/**
 * ユーザ区分を取得
 *
 * @export API通信成功時の処理
 * @class GetAssociatedUserType
 * @extends {PlessJsonResponderSub}
 */
@Injectable()
export class GetAssociatedUserTypeService extends PlessJsonResponderSub<any> {

  // 処理に使用するModel
  private model: KYMW9000Model;
  private successFunc: Function;

  constructor(
    protected plessHttp: PlessHttp,
    protected dialogService: PlessDialogServiceSub
  ) {
    super(plessHttp, dialogService);
  }

  /**
   * bodyにセットする値を返す
   *
   * @private
   * @returns {PlessRequest} リクエストJSON
   * @memberof GetAssociatedUserType
   */
  private getBody(): PlessRequest {
    return new PlessRequest({
      parameter: {
      }
    })
  }

  /**
   * API呼び出し
   *
   * @param {KYMW9000Model} model
   * @param {any} vo
   * @param {Function} [successFunc=null] 成功時後続処理
   * @memberof GetAssociatedUserType
   */
  execute(model: KYMW9000Model, successFunc: Function = null) {
    this.model = model;
    this.successFunc = successFunc;
    this.send('getAssociatedUserType', this.getBody());
  }

  /**
   * API通信成功時の処理
   *
   * @param {*} data レスポンスデータ
   * @memberof GetAssociatedUserType
   */
  success(data: any) {
    this.model.updateUserTypeCombobox(data);
    if ( PlessViewUtilsSub.isEmptyArray(this.model.associatedUserTypeList)) {
      this.dialogService.openAlert('システムエラーが発生しました', 'S');
    }
    if (this.successFunc !== null) {
      this.successFunc(data);
    }
  }
}
